import {
  CheckCircleOutline,
  ErrorOutline,
  ReportProblemOutlined,
  InfoOutlined,
} from '@mui/icons-material';
import { ClassNameMap } from '@mui/material';
import { VariantType } from 'notistack';
import React from 'react';

/**
 *
 * @param variant VariantType  - Type of notification toast from notistack
 * @param classes ClassNameMap - Output of a `makeStyles`
 * @returns
 */
export const getNotificationClass = (variant: VariantType, classes: ClassNameMap) => {
  return classes[variant];
};

export const getNotificationTypeIcon = (variant: VariantType) => {
  switch (variant) {
    case 'success':
      return <CheckCircleOutline />;
    case 'error':
      return <ErrorOutline />;
    case 'warning':
      return <ReportProblemOutlined />;
    case 'info':
      return <InfoOutlined />;
    default:
      return null;
  }
};
